'use client';

import { LinkWithChildren } from 'mode-shared/components/Header/types';
import { MobileMenu } from 'mode-shared/components';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { DropdownNavMenu } from 'mode-shared/components/Header/components/DropdownNavMenu';
import { usePathname } from 'next/navigation';
import { twMerge } from 'tailwind-merge';

export const Header = ({
  links,
  right,
  logo,
  className,
}: {
  links: LinkWithChildren[];
  right?: React.ReactNode;
  logo: React.ReactNode;
  className?: string;
}) => {
  const currentRoute = usePathname();

  return (
    <header
      className={twMerge(
        'sticky top-0 z-50 border-neutral-900 border-b h-[80px] bg-neutral-black px-4 lg:px-0',
        className
      )}
    >
      <div className="h-full flex items-center justify-between max-w-[1200px] mx-auto">
        <div className="flex items-center h-full">
          <MobileMenu links={links} className="flex lg:hidden" />
          {logo}
          <div className="space-x-2 hidden lg:flex items-center lg:ml-[64px]">
            {links.map(({ text, href, disabled, children, target, icon, hide }) => {
              if (hide) {
                return null;
              }

              if (children && children.length > 0) {
                return <DropdownNavMenu key={`${text}-${href}`} name={text} items={children} />;
              }
              if (icon) {
                return (
                  <Link href={href} target={target} key={text}>
                    <div className="p-2 w-8 h-8 flex items-center justify-center">
                      <Image className="w-full" src={icon} alt={text} width={24} height={24} />
                    </div>
                  </Link>
                );
              }

              return (
                <Link
                  key={text}
                  href={href}
                  target={target}
                  className={clsx(
                    disabled && 'pointer-events-none text-neutral-600',
                    currentRoute?.includes(href) && 'text-primary',
                    'hover:bg-primary/8 hover:border-primary/8',
                    'flex items-center gap-2 p-2 text-neutral-100 font-medium border border-transparent rounded-lg uppercase text-sm xl:text-base'
                  )}
                >
                  {text}
                </Link>
              );
            })}
          </div>
        </div>
        {right}
      </div>
    </header>
  );
};
